// 張本対応: custom.jsの追加
// featured collectionのSP機能の追加
(function () {
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  function applyColorFilter(colorValue) {
    const input = document.querySelector(
      `.filter-form input.tag__input[type="checkbox"][value="${CSS.escape(colorValue)}"]`
    );
    if (!input) return false;

    // 単一選択にしたいなら、同じフィルター内の他チェックを外す処理をここに入れる
    input.checked = !input.checked;

    // テーマ側の監視に引っかける（change）
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function swapCardImage(swatchEl) {
    const url = swatchEl.getAttribute('data-variant-image');
    if (!url) return false;

    // このスウォッチが属する商品カードを探す
    const card = swatchEl.closest('.grid-product');
    if (!card) return false;

    // 代表画像の img を探す（Impulseの構造に合わせて広めに拾う）
    const img =
      card.querySelector('.grid-product__image-mask img') ||
      card.querySelector('.grid__item-image-wrapper img');

    if (!img) return false;

    // 画像差し替え（srcsetが残ると戻る場合があるので消す）
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;

    return true;
  }

  function setActiveSwatch(swatchEl) {
  const wrap = swatchEl.closest('.grid-product__colors');
  if (!wrap) return;

  // 同じカード内の他スウォッチの選択を解除
  wrap.querySelectorAll('a.color-swatch.is-active').forEach(el => {
    el.classList.remove('is-active');
  });

  // クリックしたやつを選択状態に
  swatchEl.classList.add('is-active');
}


  document.addEventListener(
    'click',
    function (e) {
      const swatch = e.target.closest('.grid-product__colors a.color-swatch');
      if (!swatch) return;

      if (!isMobile()) return;

      // SPでは遷移（商品ページへのリンク）を止める
      e.preventDefault();
      e.stopPropagation();
      
      setActiveSwatch(swatch);

      // 1) カード画像を切り替え（あれば）
      swapCardImage(swatch);

      // 2) コレクションを色で絞り込む（あれば）
      const colorValue = swatch.getAttribute('data-color-value');
      if (colorValue) applyColorFilter(colorValue);
    },
    { passive: false }
  );
})();
